import { DarkPopup } from '@elements/Popup';
import { tooltipTexts } from '@utility/constants/common';
import React from 'react';

export function PermissionTooltip(props) {
  const {
    children,
    disabled,
    hidden,
    position = 'top center',
    wrapperClassName = '',
    skipPermission,
  } = props ?? {};

  if (skipPermission) {
    return wrapperClassName ? (
      <div className={wrapperClassName}>{children}</div>
    ) : (
      children
    );
  }

  if (hidden) {
    return null;
  }

  if (disabled) {
    return (
      <DarkPopup
        position={position}
        trigger={<div className={wrapperClassName}>{children}</div>}
      >
        {tooltipTexts.missingPermission}
      </DarkPopup>
    );
  }

  return wrapperClassName ? (
    <div className={wrapperClassName}>{children}</div>
  ) : (
    children
  );
}

export default PermissionTooltip;
